import { Checkbox, makeStyles } from '@material-ui/core'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import React, { FC, memo } from 'react'

const useStyles = makeStyles(theme => ({
  checkboxChecked: {
    color: theme.palette.text.primary
  },
  checkboxUnchecked: {
    color: theme.palette.text.disabled
  }
}))

type EnhancedBookQtyCheckboxProps = {
  isProductActive: boolean
  isAnyBookUnbookInProgress: boolean
  isBookUnbookAllInProgress: boolean
  areAllDoorsBooked: boolean
  isOrderEditable: boolean
  statusChangeHandler: (e: any, checked: any) => void
}

/**
 * Product-level book/unbook-all checkbox
 */
const EnhancedBookQtyCheckbox: FC<EnhancedBookQtyCheckboxProps> = ({
  isProductActive,
  isAnyBookUnbookInProgress,
  isBookUnbookAllInProgress,
  areAllDoorsBooked,
  isOrderEditable,
  statusChangeHandler
}) => {
  const classes = useStyles()
  return (
    <Checkbox
      className={areAllDoorsBooked ? classes.checkboxChecked : classes.checkboxUnchecked}
      size='small'
      color='default'
      icon={<CheckBoxOutlineBlankIcon fontSize='small' />}
      checkedIcon={<CheckBoxIcon fontSize='small' />}
      checked={areAllDoorsBooked}
      // Graying out during book/unbook is nice here, it acts a visual cue that work is in progress
      disabled={isAnyBookUnbookInProgress || !isOrderEditable || !isProductActive}
      // Indeterminate state is shown when user is booking/unbooking individual doors since we don't know the outcome
      indeterminate={isAnyBookUnbookInProgress && !isBookUnbookAllInProgress}
      onChange={statusChangeHandler}
    />
  )
}

export default memo(EnhancedBookQtyCheckbox)
